const DEFAULT_PROD_BASE = '/patacat_complete';

const detectBasePath = () => {
  if (process.env.NODE_ENV !== 'production') {
    return process.env.REACT_APP_BASENAME || '/';
  }

  if (typeof window !== 'undefined') {
    const path = window.location.pathname || '';
    if (path.startsWith('/patacat_complete')) {
      return '/patacat_complete';
    }
  }

  return DEFAULT_PROD_BASE;
};

const BASENAME = detectBasePath();

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? `${BASENAME}/api`
  : '/api';

export const config = {
  apiBaseUrl: API_BASE_URL,
  basename: BASENAME
};

export default config;
